import { ItemIDs } from './Items';

export const TutorialLevelTriggers: number[] = [1, 3, 6, 9, 12, 18, 21, 30];
export const TutorialStuckLevelTriggers: number[] = [15, 30];

export type TTutorial = ITutorialStep[];

export interface ITutorialStep {
    animateBox: boolean;
    dialog: string;
    actions: TutorialActions[];
    dismiss: boolean;
    dismissText: boolean;
    characterEntrance: number;
    animations?: string[];
    boosterId?: ItemIDs;
    waitTime?: number;
    startPause?: boolean;
    endPause?: boolean;
    pauseBoard?: boolean;
}

export enum TutorialActions {
    TAP = 'tap',
    WAIT = 'wait',
    MATCH = 'match',
    MATCH_GOLD = 'match gold',
    FIND = 'find',
    LOSS_AVERSION = 'avoid fail',
    SHOW_BOOSTER = 'show booster',
    ACTIVATE_BOOSTER = 'activate booster',
    COMPLETE_BOOSTER = 'complete booster',
    ADD_BOOSTER = 'add booster',
    DISMISS = 'dismiss',
}

export const MatchTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'MatchTutorial01',
        characterEntrance: 3,
        actions: [TutorialActions.TAP, TutorialActions.WAIT],
        dismiss: false,
        dismissText: false,
        waitTime: 2000,
    },
    {
        animateBox: true,
        dialog: 'MatchTutorial02',
        characterEntrance: 3,
        actions: [TutorialActions.MATCH],
        dismiss: false,
        dismissText: false,
    },
    {
        animateBox: true,
        dialog: 'MatchTutorial03',
        actions: [TutorialActions.MATCH],
        characterEntrance: 3,
        dismiss: true,
        dismissText: true,
    },
];

export const GoldenTilesTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'GoldenTilesTutorial01',
        characterEntrance: 3,
        actions: [TutorialActions.MATCH_GOLD],
        dismiss: false,
        dismissText: false,
    },
    {
        animateBox: true,
        dialog: 'GoldenTilesTutorial02',
        characterEntrance: 3,
        actions: [TutorialActions.MATCH_GOLD],
        dismiss: true,
        dismissText: true,
    },
];

export const FindTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'FindTutorial01',
        actions: [TutorialActions.FIND],
        characterEntrance: 3,
        dismiss: false,
        dismissText: false,
    },
    {
        animateBox: true,
        dialog: 'FindTutorial02',
        actions: [TutorialActions.WAIT],
        characterEntrance: 3,
        dismiss: true,
        dismissText: true,
        waitTime: 3000,
    },
];

export const ShuffleTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'ShuffleTutorial01',
        animations: [`show-booster-${ItemIDs.SHUFFLE}`],
        actions: [TutorialActions.LOSS_AVERSION],
        characterEntrance: 4,
        dismiss: false,
        dismissText: false,
    },
];

export const ClockTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'ClockTutorial01',
        animations: [`show-booster-${ItemIDs.TIME}`],
        actions: [TutorialActions.LOSS_AVERSION],
        characterEntrance: 4,
        dismiss: false,
        dismissText: false,
    },
];

export const FlashlightTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'FlashlightTutorial01',
        animations: [`show-booster-${ItemIDs.HIGHLIGHT}`],
        actions: [TutorialActions.WAIT],
        characterEntrance: 4,
        dismiss: false,
        dismissText: false,
        startPause: true,
        waitTime: 1000,
    },
    {
        animateBox: false,
        dialog: 'FlashlightTutorial01',
        animations: [`show-booster-${ItemIDs.HIGHLIGHT}`],
        actions: [TutorialActions.SHOW_BOOSTER],
        boosterId: ItemIDs.HIGHLIGHT,
        characterEntrance: 4,
        dismiss: true,
        dismissText: true,
        pauseBoard: true,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.WAIT],
        characterEntrance: 0,
        dismiss: false,
        dismissText: false,
        waitTime: 0,
    },
];

export const FireworksTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'FireworksTutorial01',
        animations: [`show-booster-${ItemIDs.FIRECRACKER}`],
        actions: [TutorialActions.WAIT],
        characterEntrance: 4,
        dismiss: false,
        dismissText: false,
        startPause: true,
        waitTime: 1000,
    },
    {
        animateBox: false,
        dialog: 'FireworksTutorial01',
        animations: [`show-booster-${ItemIDs.FIRECRACKER}`],
        actions: [TutorialActions.SHOW_BOOSTER],
        boosterId: ItemIDs.FIRECRACKER,
        characterEntrance: 4,
        dismiss: true,
        dismissText: true,
        pauseBoard: true,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.WAIT],
        characterEntrance: 0,
        dismiss: false,
        dismissText: false,
        pauseBoard: true,
        waitTime: 3000,
    },
    {
        animateBox: false,
        dialog: 'FireworksTutorial02',
        animations: [`show-booster-${ItemIDs.FIRECRACKER}`],
        actions: [TutorialActions.ACTIVATE_BOOSTER],
        boosterId: ItemIDs.FIRECRACKER,
        characterEntrance: 4,
        dismiss: true,
        dismissText: true,
        endPause: true,
        pauseBoard: true,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.WAIT],
        characterEntrance: 0,
        dismiss: false,
        dismissText: false,
        pauseBoard: true,
        waitTime: 3000,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.WAIT],
        characterEntrance: 0,
        dismiss: false,
        dismissText: false,
        pauseBoard: false,
        waitTime: 0,
    },
];

export const SeasonsTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'SeasonsTutorial01',
        actions: [TutorialActions.MATCH],
        characterEntrance: 3,
        dismiss: false,
        dismissText: false,
    },
    {
        animateBox: true,
        dialog: 'SeasonsTutorial02',
        actions: [TutorialActions.MATCH],
        characterEntrance: 3,
        dismiss: true,
        dismissText: true,
    },
];

export const MagnetTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'MagnetTutorial01',
        animations: [`show-booster-${ItemIDs.MAGNET}`],
        actions: [TutorialActions.WAIT],
        characterEntrance: 4,
        dismiss: false,
        dismissText: false,
        startPause: true,
        waitTime: 1000,
    },
    {
        animateBox: false,
        dialog: 'MagnetTutorial01',
        animations: [`show-booster-${ItemIDs.MAGNET}`],
        actions: [TutorialActions.SHOW_BOOSTER],
        boosterId: ItemIDs.MAGNET,
        characterEntrance: 4,
        dismiss: true,
        dismissText: true,
        pauseBoard: true,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.COMPLETE_BOOSTER],
        boosterId: ItemIDs.MAGNET,
        characterEntrance: 0,
        dismiss: true,
        dismissText: true,
    },
    {
        animateBox: false,
        dialog: '',
        actions: [TutorialActions.WAIT],
        characterEntrance: 0,
        dismiss: false,
        dismissText: false,
        waitTime: 2000,
    },
    /*    {
        animateBox: false,
        dialog: 'MagnetTutorial02',
        actions: [TutorialActions.WAIT],
        characterEntrance: 4,
        dismiss: true,
        dismissText: true,
        pauseBoard: false,
        waitTime: 3000,
    },*/
];

export const TimedLevelTutorial: TTutorial = [
    {
        animateBox: false,
        dialog: 'TimedLevelTutorial01',
        characterEntrance: 3,
        actions: [TutorialActions.TAP],
        dismiss: true,
        dismissText: true,
    },
];
export const TutorialStages: any[] = [
    MatchTutorial,
    GoldenTilesTutorial,
    FireworksTutorial,
    FlashlightTutorial,
    FindTutorial,
    SeasonsTutorial,
    MagnetTutorial,
    TimedLevelTutorial,
];

export const StuckTutorialStages: any[] = [ShuffleTutorial, ClockTutorial];
